import * as React from 'react';
import sidebarContext, { ISidebarContext } from './context';

export type UseSidebarHook = () => ISidebarContext;

export const useSidebar: UseSidebarHook = (): ISidebarContext => {
  const { collapsed, toggleCollapse } = React.useContext(sidebarContext);
  return { collapsed, toggleCollapse };
};
